import CalculatorHelper from '@/services/calculator-service-helper';
import _ from 'lodash';

export default {
    calculateFinalScores: calculateFinalScores,
    normaliseBrandMetrics: (projectBrandMetrics, metricWeights, min, max, isWeighted) => {
        return normaliseAndWeightBrandMetric(projectBrandMetrics, metricWeights, min, max, isWeighted);
    }
};

function calculateFinalScores (finalMetricData, pillarWeights) {
    let results = [];
    // For each brand column add all the property values in each axis to produce the final score for X, Y and Z axis
    _.each(finalMetricData, (data) => {
        let xConversationSum = _.reduce(data.xConversation, (r, v) => r + v);
        let yQualitySum = _.reduce(data.yQuality, (r, v) => r + v);
        let zCommunitySum = _.reduce(data.zCommunity, (r, v) => r + v);

        let brandData = {
            columnId: data.columnId,
            xConversation: xConversationSum,
            yQuality: yQualitySum,
            zCommunity: zCommunitySum,
            finalScore: CalculatorHelper.calculateFinalScore(
                xConversationSum, yQualitySum, zCommunitySum, pillarWeights)
        };
        results.push(brandData);
    });
    return results;
}

function normaliseAndWeightBrandMetric (projectBrandMetrics, metricWeights, min, max, isWeighted) {
    let brandMetricDict = {};
    _.each(metricWeights, (metricWeight) => {
        let metricField = metricWeight.sysMetric;
        let minVal = min[metricField] || 0;
        let maxVal = max[metricField] || 0;

        _.each(projectBrandMetrics, (metric) => {
            let obj = {
                xConversation: {},
                yQuality: {},
                zCommunity: {}
            };
            if (brandMetricDict.hasOwnProperty(metric.columnId)) {
                obj = brandMetricDict[metric.columnId];
            } else {
                obj.columnId = metric.columnId;
                brandMetricDict[metric.columnId] = obj;
            }

            let value;
            if (isWeighted) {
                // Calculate the normalised and weighted value
                value = CalculatorHelper.calculateWeightedNormalisedValue(
                    metric[metricField], metricField, minVal, maxVal, metricWeight.weight);
            } else {
                // Calculate the normalised value
                value = CalculatorHelper.calculateNormalisedValue(
                    metric[metricField], metricField, minVal, maxVal);
            }

            // Add the value to the relevant axis
            switch (metricWeight.axis) {
            case 'X':
                obj.xConversation[metricField] = value;
                break;
            case 'Y':
                obj.yQuality[metricField] = value;
                break;
            case 'Z':
                obj.zCommunity[metricField] = value;
                break;
            default:
                obj[metricField] = value;
                break;
            }
        });
    });

    return _.toArray(brandMetricDict);
}
